import type { IconSvgObject } from './types';

const CurrencyIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "9", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18.5 5.5L21 3M5.5 5.5L3 3M5.5 18.5L3 21M18.5 18.5L21 21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["circle", { cx: "12", cy: "12", r: "5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default CurrencyIcon;
